import React from "react";
export function useCanLoadImage(src: string) {
    const [loaded, setLoaded] = React.useState<"error" | "loading" | true>("loading");
    React.useEffect(() => {
        if (!src) {
            return undefined;
        }
        setLoaded("loading");
        let active = true;
        const image = new Image();
        image.onload = () => {
            if (!active) {
                return;
            }
            setLoaded(true);
        };
        image.onerror = () => {
            if (!active) {
                return;
            }
            setLoaded("error");
        };
        image.src = src;
        return () => {
            active = false;
        };
    }, [src]);
    return loaded;
}
